import React, { useEffect, useState } from "react";
import { StyleSheet, View } from "react-native";
import { clone } from "lodash";

import AppTheme from "../../../AppTheme";
import Icons from "../../../common/icons";
import { getGoalProgressColor } from "../../../common/mood/MoodsHelper";
import ComparisonChart from "./ComparisonChart";
import ComparisonAverages from "./ComparisonAverages";
import ComparisonSentence from "./ComparisonSentence";
import ComparisonElement from "./ComparisonElement";
import ComparisonContentHours from "./ComparisonContentHours";

export default function ComparisonContent({
  data,
  selectedDate,
  timeUnit = "week",
  showJournalDialog,
  onDateChanged = () => {},
  showToggleChartMenu = () => {},
}) {
  if (!data) return null;

  const [selectedAverages, setSelectedAverages] = useState({});
  const [currentDayData, setCurrentDayData] = useState({});

  // ------------------------------------- METHODS -------------------------------------
  useEffect(() => {
    if (!selectedDate) return;

    let dt = data.reflection_hours
      ? data.reflection_hours[selectedDate] || {}
      : {};

    // To open journal dialog on reflection edit page
    if (!dt.gem) dt.gem = {};

    setCurrentDayData(dt);
  }, [selectedDate, data.reflection_hours]);

  const onAverageSelected = (selected) => {
    if (selectedAverages[selected]) {
      delete selectedAverages[selected];
    } else {
      selectedAverages[selected] = true;
    }

    setSelectedAverages(clone(selectedAverages));
  };

  // ------------------------------------- RENDER -------------------------------------
  const totalMinutes = data.hours * 60;
  const element = data.element || {};

  const goal = data.goal || {};
  const goalMinutes = goal.partial_target_hours * 60;
  const progressColor = goal.mood
    ? getGoalProgressColor(goal)
    : AppTheme.almostBlack;

  return (
    <>
      {/* Element */}
      <ComparisonElement element={element} />

      {/* Text & Mood */}
      <View
        style={{
          flexDirection: "row",
          paddingBottom: 4,
        }}
      >
        <ComparisonSentence
          data={data}
          selectedDate={selectedDate}
          timeUnit={timeUnit}
        />

        {showJournalDialog ? (
          <Icons.Journal
            fillColor={AppTheme.almostBlack}
            mood={currentDayData.gem?.mood}
            onPress={() => showJournalDialog(currentDayData?.gem)}
          />
        ) : null}
      </View>

      {/* Hours */}
      <ComparisonContentHours
        goalMinutes={goalMinutes}
        totalMinutes={totalMinutes}
        goal={goal}
      />

      {/* Chart & Averages */}
      <View style={styles.chartContainer}>
        <ComparisonChart
          data={data}
          timeUnit={timeUnit}
          progressColor={progressColor}
          selectedDate={selectedDate}
          selectedAverages={selectedAverages}
          onDateChanged={onDateChanged}
          showToggleChartMenu={showToggleChartMenu}
          showJournalDialog={showJournalDialog}
        />
        <ComparisonAverages
          averages={data.averages}
          selectedAverages={selectedAverages}
          onAverageSelected={onAverageSelected}
        />
      </View>
    </>
  );
}

const styles = StyleSheet.create({
  chartContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    borderBottomColor: AppTheme.lightGray,
    borderBottomWidth: 1,
  },
});
